import React, { FC } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { CompanyEditorFieldWithCreateModeProps } from "../../CompanyEditor.types";

import { TextField, Typography } from "@components/base";

const CompanyVat: FC<CompanyEditorFieldWithCreateModeProps> = ({
  control,
  isCreateMode,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="body2" color="text.secondary">
        {t("organizationSettings.vat")}
        {isCreateMode && " *"}
      </Typography>
      <Controller
        name="vat"
        control={control}
        rules={{ required: true }}
        render={({ field, fieldState: { error } }) => (
          <TextField
            variant="filled"
            fullWidth
            placeholder={t("organizationSettings.vat")}
            error={!!error}
            {...field}
          />
        )}
      />
    </>
  );
};

export default CompanyVat;
